// extracted by mini-css-extract-plugin
export default {"button":"qr-z","reviewSort":"rr-z"};